import React, { useEffect, useState } from "react";
import style from "./LearningDetail.module.css";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { FiPower } from "react-icons/fi";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BsFileBarGraph } from "react-icons/bs";
import Loader from "../Loder/Loader";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { baseurl } from "../Url";
import { PiExam } from "react-icons/pi";
import { BsBookHalf } from "react-icons/bs";
import { Doughnut } from "react-chartjs-2";
import { AnimationData } from "../../Animation/AnimationData";
import Lottie from "lottie-react";
import { IoPersonCircleOutline } from "react-icons/io5";
import goldMedal from "../../assests/goldnew-removebg-preview.png";
import silverMedal from "../../assests/silvercutnew-removebg-preview.png";
import brownsMedal from "../../assests/brownNew-removebg-preview.png";
import Whiteboard from "../WhiteBoard/WhiteBoard";
import { BiClipboard } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { VscGraph } from "react-icons/vsc";
import { LuBook } from "react-icons/lu";
import { MdMoreVert, MdArrowBack } from "react-icons/md";

const LearningDetail = () => {
  const location = useLocation();
  const state = location.state || {};
  console.log(state);
  const Details = state.learning_detail || {};
  const subsFromState = Array.isArray(state.subs) ? state.subs : [];
  const peerRole = state?.peerRole;
  const returnPath = state?.returnPath === "/skills" ? "/skills" : "/learnings";
  const learn_id = localStorage.getItem("newLearningId");
  const key = JSON.parse(localStorage.getItem("access-token"));
  const [topicDetail, setTopicDetail] = useState([]);
  const navigate = useNavigate();
  const outletCtx = useOutletContext();
  const onMenuToggle = outletCtx?.onMenuToggle;
  const sidebarOpen = outletCtx?.sidebarOpen;
  const [loading, setLoading] = useState(true);
  const learnertoken = localStorage.getItem("learnertoken");
  const [token, setToken] = useState(learnertoken ? learnertoken : key);
  const [popup, setPopup] = useState(false);
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");
  const [graphData, setGraphData] = useState([]);
  const [assessmentData, setAssessmentData] = useState({});
  const learneruserid = localStorage.getItem("learneruserid");
  const [user_ID, setUser_ID] = useState(
    peerRole !== undefined ? learneruserid : USERID
  );

  const [learningData, setLearningData] = useState({});
  const [cardListDetail, setCardListDetail] = useState([]);
  const [leaderBoardShow, setLeaderBoardShow] = useState(false);
  const [rewardValues, setRewardValues] = useState([]);
  const [mainTopicId, setMainTopicId] = useState("");
  const [clubId, setClubId] = useState("");
  // const [whiteBoradShow, setWhiteBoardShow] = useState(false);
  const [whiteBoradIconShow, setWhiteBoardIconShow] = useState(true);
  const [moduleList, setModuleList] = useState([]);

  const [subscriptionPopup, setSubscriptionPopup] = useState(false);

  const [expandedModule, setExpandedModule] = useState(null);

  const [topicGetData, setTopicGetData] = useState([]);

  const isObjectIdLike = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    return /^[a-f\d]{24}$/i.test(trimmed);
  };

  const resolveCourseTitle = () => {
    const fromState = state.title;
    if (typeof fromState === "string" && fromState.trim()) return fromState.trim();

    const directCandidates = [
      Details.Name,
      Details.course_name,
      Details.CategoryName,
      Details.CourseName,
      Details.category_details,
      Details.title,
    ];

    for (const candidate of directCandidates) {
      if (typeof candidate === "string") {
        const value = candidate.split(",")[0].trim();
        if (value && !isObjectIdLike(value)) return value;
      }
    }

    const categories = Details.Categories;
    if (Array.isArray(categories) && categories.length > 0) {
      const first = categories[0];
      if (typeof first === "string") {
        const value = first.trim();
        if (value && !isObjectIdLike(value)) return value;
      }
      if (first && typeof first === "object") {
        const nestedCandidates = [
          first.category_details,
          first.Name,
          first.course_name,
          first.CategoryName,
          first.title,
        ];
        for (const candidate of nestedCandidates) {
          if (typeof candidate === "string") {
            const value = candidate.trim();
            if (value && !isObjectIdLike(value)) return value;
          }
        }
      }
    }

    return "Learning";
  };

  const handleExpand = (moduleId) => {
    setExpandedModule((prev) => (prev === moduleId ? null : moduleId));
  };

  async function rewardPoint() {
    await fetch(`${baseurl}/reward/dashboard`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        club_id: clubId,
        main_topic_id: mainTopicId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setRewardValues(data.data);
      });
  }

  // Function to fetch module list
  async function fetchModuleList() {
    try {
      const org_id = localStorage.getItem("ORGID");

      if (!org_id) {
        throw new Error("org_id not found in local storage");
      }

      const response = await fetch(`${baseurl}/module/list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ org_id }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch module list");
      }

      const data = await response.json();
      setModuleList(data.data);
    } catch (error) {
      console.error("Error fetching module list:", error);
    }
  }

  // function doesModuleExist(moduleId) {
  //   return moduleList.some((mod) => mod.module_id === moduleId);
  // }

  function isModuleActive(moduleId) {
    const module = moduleList.find((mod) => mod.module_id === moduleId);
    return module && module.module_status === "active";
  }

  function isModuleFree(moduleId) {
    const module = moduleList.find((mod) => mod.module_id === moduleId);
    return module && module.module_price === "free";
  }

  function isModulePaid(moduleId) {
    const module = moduleList.find((mod) => mod.module_id === moduleId);
    return module && module.module_type === "paid";
  }

  function isModuleEnabled(moduleId) {
    const module = moduleList.find((mod) => mod.module_id === moduleId);
    return module && module.module_state === "enabled";
  }

  useEffect(() => {
    fetchModuleList();
  }, []);

  // Note: module/topic list is now sourced from /userlearning/details/individual (cardDetail)

  async function cardDetail() {
    try {
      const USERID_LOCAL = localStorage.getItem("USERID");
      const OrgID_LOCAL = localStorage.getItem("ORGID");

      // Resolve user_learning_id from multiple sources (localStorage, state, learning_detail)
      let effectiveLearningId =
        learn_id ||
        state.user_learning_id ||
        state.learningId ||
        Details.learning_id ||
        Details.user_learning_id ||
        Details.userlearning_id;

      // Persist to localStorage when resolved from state so API calls and refreshes work
      if (effectiveLearningId && !learn_id) {
        localStorage.setItem("newLearningId", String(effectiveLearningId));
      }

      // Always ping /skills/learning/get on load if we have a user_learning_id
      if (effectiveLearningId) {
        try {
          const keyRaw = localStorage.getItem("access-token");
          let tokenLocal = keyRaw;
          try {
            tokenLocal = keyRaw ? JSON.parse(keyRaw) : null;
          } catch {
            tokenLocal = keyRaw;
          }

          const getRes = await fetch(`${baseurl}/skills/learning/get`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...(tokenLocal && { Authorization: `Bearer ${tokenLocal}` }),
            },
            body: JSON.stringify({
              user_learning_id: String(effectiveLearningId),
            }),
          });
          const getData = await getRes.json();
          console.log("skills/learning/get in /lerning/detail:", getData);
          // We already have effectiveLearningId from Start Learning, so we only log/confirm here
        } catch (err) {
          console.error("Error in /skills/learning/get from cardDetail:", err);
        }
      }

      if (!effectiveLearningId) {
        setTopicDetail([]);
        setLoading(false);
        return;
      }

      // 2) Use user_learning_id from /skills/learning/get (or fallback) in /userlearning/details/individual
      const response = await fetch(
        `${baseurl}/userlearning/details/individual`,
        {
          method: "POST",
          body: JSON.stringify({
            user_id: USERID_LOCAL,
            userlearning_id: effectiveLearningId,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      console.log("TEST DUNO LOG /userlearning/details/individual:", data);

      if (data && data.data && data.data.length > 0) {
        setTopicDetail(data.data);

        const first = data.data[0] || {};
        // So module clicks can call /ai/lesson/generation/for/user even before piChart() fills learningData
        setLearningData((prev) => ({
          ...prev,
          learning_id: first.learning_id || effectiveLearningId,
          admin_mapped_lessons:
            first.admin_mapped_lessons ??
            first.admin_mapped ??
            prev.admin_mapped_lessons ??
            Details.admin_mapped_lessons,
        }));
        const modulesFromIndividual =
          (Array.isArray(first.Topics) && first.Topics) ||
          (Array.isArray(first.topics) && first.topics) ||
          [];
        setTopicGetData(modulesFromIndividual);

        if (modulesFromIndividual.length > 0) {
          setMainTopicId(modulesFromIndividual[0].topic_id);
        }
      } else {
        setTopicDetail([]);
        setTopicGetData([]);
      }
    } catch (error) {
      console.error("Error fetching card detail:", error);
      setTopicDetail([]);
    } finally {
      setLoading(false);
    }
  }

  async function piChart() {
    try {
      const response = await fetch(`${baseurl}/userlearning/details`, {
        method: "POST",
        body: JSON.stringify({ user_id: user_ID }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      console.log(data);

      if (data && data.data && data.data.length > 0) {
        setCardListDetail(data.data[0]);
        setClubId(data.data[0].club_id);

        if (data.status === true) {
          const modifiedData = data.data.map((item) => {
            const topicsWithNoModuleName = [];
            const topicsWithModuleName = [];

            item.Topics = item.Topics || [];
            item.Topics.forEach((topic) => {
              if (!topic.module_name) {
                topic.module_name = "General topics";
                topicsWithNoModuleName.push(topic);
              } else {
                topicsWithModuleName.push(topic);
              }
            });

            item.Topics = [
              ...topicsWithModuleName,
              ...topicsWithNoModuleName,
            ].map((topic) => {
              topic.isExpand = false;
              return topic;
            });

            return item;
          });
          setLearningData(modifiedData[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching pi chart data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }

  async function barGraph(topic) {
    await fetch(`${baseurl}/individual/topic/analytics`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        user_id: user_ID,
        topic_id: topic,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setLoading(false);
        if (
          data &&
          data.data &&
          data.data[0] &&
          data.data[0].completion_percentage
        ) {
          setGraphData(data.data[0].completion_percentage);
          setLoading(false);
          setAssessmentData({
            Total_attempted_assessments:
              data.data[0].Total_attempted_assessments,
            Total_correct_answers: data.data[0].Total_correct_answers,
            Total_incorrect_answers: data.data[0].Total_incorrect_answers,
          });
        } else {
          console.error(
            "Completion percentage data not found in the API response."
          );
        }
      });
  }
  useEffect(() => {
    console.log(graphData);
  }, [graphData]);
  const data = {
    labels: graphData.map((item) => item.x),
    datasets: [
      {
        label: "Completion percentage",
        data: graphData.map((item) => item.y),
        backgroundColor: "#1a1e5d",
        barThickness: 50,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        type: "linear",
        beginAtZero: true,
        max: 100,
        min: 0,
        stepSize: 10,
        suggestedMin: 0,
        suggestedMax: 100,
        ticks: {
          callback: function (value) {
            return value + "%";
          },
        },
      },
    },
  };

  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (closing) {
      setTimeout(() => {
        setClosing(false);
      }, 1000);
    }
  }, [closing]);

  useEffect(() => {
    cardDetail();
    piChart();
  }, []);

  /** User learning row id — required by /ai/lesson/generation/for/user (from /skills flow use state + localStorage). */
  const resolveUserLearningId = () =>
    learningData?.learning_id ||
    Details.learning_id ||
    Details.user_learning_id ||
    Details.userlearning_id ||
    state.user_learning_id ||
    learn_id ||
    (typeof window !== "undefined" ? localStorage.getItem("newLearningId") : null);

  async function generateAiLessonForUser(topic, module) {
    try {
      if (!topic) return;
      const topicId = topic.id || topic.topic_id || topic._id;
      const topicName = topic.value || topic.name || topic.topic_name || "";
      if (!topicId) return;

      const learningId = resolveUserLearningId();
      const mappedLessons =
        learningData.admin_mapped_lessons ?? Details.admin_mapped_lessons;
      const mainTopicIdLocal =
        module?.topic_id ||
        module?.main_topic_id ||
        mainTopicId ||
        localStorage.getItem("main_topic_id");

      if (!OrgID || !USERID || !learningId || !mainTopicIdLocal) return;

      // Persist for downstream pages which rely on localStorage
      localStorage.setItem("main_topic_id", String(mainTopicIdLocal));

      await fetch(`${baseurl}/ai/lesson/generation/for/user`, {
        method: "POST",
        body: JSON.stringify({
          Organization_ID: OrgID,
          topic_id: topicId,
          topic_name: topicName,
          learning_id: learningId,
          main_topic_id: mainTopicIdLocal,
          user_id: USERID,
          admin_mapped: mappedLessons,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (err) {
      console.warn("Prefetch /ai/lesson/generation/for/user failed:", err);
    }
  }

  const handleCardClick = (moduleId, topic, module, j) => {
    if (isModulePaid(moduleId) && !isModuleFree(moduleId)) {
      setSubscriptionPopup(true);
    } else {
      const source = peerRole !== undefined ? "support" : "";
      if (topic.type === "exam") {
        navigate("/exams", {
          state: {
            exam_id: topic.id,
            examname: topic.value,
          },
        });
      } else {
        const learningId = resolveUserLearningId();
        const mappedLessons =
          learningData.admin_mapped_lessons ?? Details.admin_mapped_lessons;

        // Prefetch AI lesson generation so NewLearningDetail loads faster
        generateAiLessonForUser(topic, module);

        navigate("/new/learnings/detail", {
          state: {
            singleTopic: topic,
            learning: learningId,
            mainID: module?.topic_id || mainTopicId || localStorage.getItem("main_topic_id"),
            mapped: mappedLessons,
            peerRole: peerRole,
            topic_no: j + 1,
            learning_detail: Details,
            returnPath,
          },
        });
      }
    }
  };

  return (
    <div className={style.container}>
      {loading ? <Loader /> : ""}

      {/* {whiteBoradIconShow ? (
        <div className={style.chatboticon}>
          <div
            onClick={() => {
              setWhiteBoardShow(true);
              setWhiteBoardIconShow(false);
            }}
            className={style.icontext}
          >
            <BiClipboard className={style.WhiteboardFloatingIcon} />
            <p> Whiteboard</p>
          </div>
        </div>
      ) : (
        ""
      )} */}
      {/* {whiteBoradShow ? (
        <div
          className={`${style.WhiteBoradContainer} ${
            closing ? style.closing : ""
          }`}
        >
          <div className={style.WhiteBoradHead}>
            <div className={style.HeadText}>White Board</div>
            <div
              className={style.WhiteBoradIcon}
              onClick={() => {
                setTimeout(() => {
                  setWhiteBoardIconShow(true);
                  setWhiteBoardShow(false);
                }, 500);
                setClosing(true);
              }}
            >
              <AiOutlineClose />
            </div>
          </div>
          <div className={style.WhiteBoradContent}>
            <Whiteboard />
          </div>
        </div>
      ) : (
        ""
      )} */}
      {popup ? (
        graphData && graphData.length > 0 ? (
          <div
            className={style.PopupOverlay}
            onClick={() => {
              setPopup(false);
              setGraphData([]);
              setAssessmentData({});
            }}
          >
            <div className={style.Popup}>
              <div className={style.AssessmentData}>
                <p>
                  Total Attempted Assessments:{" "}
                  {assessmentData.Total_attempted_assessments}
                </p>
                <p>
                  Total Correct Answers: {assessmentData.Total_correct_answers}
                </p>
                <p>
                  Total Incorrect Answers:{" "}
                  {assessmentData.Total_incorrect_answers}
                </p>
              </div>
              <Bar data={data} options={options} />
            </div>
          </div>
        ) : (
          <div
            onClick={() => {
              setPopup(false);
              setGraphData([]);
              setAssessmentData({});
            }}
            className={style.PopupOverlay}
          >
            <div className={style.Popup}>No data available</div>
          </div>
        )
      ) : (
        ""
      )}
      <div className={style.header}>
        <div className={style.headerLeft}>
          <div className={style.headerLeading}>
            {typeof onMenuToggle === "function" && (
              <button
                type="button"
                className={`${style.headerMenuBtn}${sidebarOpen ? ` ${style.headerMenuBtnSuppressed}` : ""}`}
                onClick={onMenuToggle}
                aria-label={sidebarOpen ? "Menu open" : "Open menu"}
                aria-expanded={sidebarOpen}
                tabIndex={sidebarOpen ? -1 : 0}
              >
                <MdMoreVert size={22} />
              </button>
            )}
            <button
              type="button"
              className={`${style.backButton} ${style.backButtonDesktopIcon}`}
              onClick={() => {
                navigate(returnPath);
              }}
              aria-label="Back"
            >
              <MdArrowBack size={18} aria-hidden />
            </button>
          </div>
          <div className={style.headerTitle}>
            <h1>Learnings</h1>
            <p className={style.breadcrumb}>Skills / Details</p>
          </div>
          <div className={style.headerTrailing}>
            <button
              type="button"
              className={`${style.backButton} ${style.backButtonMobileChip}`}
              onClick={() => {
                navigate(returnPath);
              }}
              aria-label="Back to My Learnings"
            >
              <MdArrowBack size={16} aria-hidden />
              <span>Back</span>
            </button>
          </div>
        </div>
      </div>

      <div className={style.LessonDiv}>
        <div className={style.courseHeader}>
          <h2>{resolveCourseTitle()}</h2>
        </div>

        {subsFromState.length > 0 && (
          <div className={style.subCatalogSection}>
            <p className={style.subCatalogLabel}>Included modules & topics</p>
            <ul className={style.subCatalogList}>
              {subsFromState.map((sub) => {
                const label =
                  sub.Name ||
                  sub.name ||
                  sub.course_name ||
                  sub.category_id ||
                  "";
                if (!label) return null;
                return <li key={sub.category_id || sub.id || label}>{label}</li>;
              })}
            </ul>
          </div>
        )}

        {/* <div className={style.overviewCard}>
          <div className={style.overviewGrid}>
            <div className={style.overviewInfo}>
              <div className={style.infoItem}>
                <span className={style.infoLabel}>Goal</span>
                <span className={style.infoValue}>{Details.goal}</span>
              </div>
              <div className={style.infoItem}>
                <span className={style.infoLabel}>Timeline</span>
                <span className={style.infoValue}>{Details.timeline} Month</span>
              </div>
              <div className={style.infoItem}>
                <span className={style.infoLabel}>Modules</span>
                <span className={style.infoValue}>{Details.Topics.length}</span>
              </div>
              <div className={style.infoItem}>
                <span className={style.infoLabel}>Assessments</span>
                <span className={style.infoValue}>{Details.assessment_done} / {Details.total_assessment}</span>
              </div>
              <div className={style.infoItem}>
                <span className={style.infoLabel}>Status</span>
                <div className={style.statusTag}>
                  <span
                    className={style.statusIndicator}
                    style={{
                      backgroundColor:
                        Details.Status === "Not Started"
                          ? "#FF4D4D"
                          : Details.Status === "In Progress"
                            ? "#FF9F43"
                            : Details.Status === "Completed"
                              ? "#28C76F"
                              : "#82868B",
                    }}
                  ></span>
                  <span className={style.statusText}>{Details.Status}</span>
                </div>
              </div>
            </div>

            <div className={style.overviewProgress}>
              <div className={style.chartBox}>
                <Doughnut
                  data={{
                    labels: ["Completed", "Remaining"],
                    datasets: [
                      {
                        data: [
                          cardListDetail.assessment_done,
                          cardListDetail.total_assessment - cardListDetail.assessment_done,
                        ],
                        backgroundColor: ["#595bdb", "#E9E9FF"],
                        borderWidth: 0,
                        cutout: "75%",
                      },
                    ],
                  }}
                  options={{
                    plugins: {
                      legend: { display: false },
                      tooltip: { enabled: false }
                    },
                    maintainAspectRatio: false
                  }}
                />
                <div className={style.chartPercentage}>
                  {cardListDetail.total_assessment !== 0
                    ? `${Math.round((cardListDetail.assessment_done / cardListDetail.total_assessment) * 100)}%`
                    : "0%"}
                </div>
              </div>
              <p className={style.progressLabel}>Course Completion</p>
              <button
                className={style.leaderboardBtn}
                onClick={(event) => {
                  event.stopPropagation();
                  setLeaderBoardShow(true);
                  rewardPoint();
                }}
              >
                Leaderboard
              </button>
            </div>
          </div>
        </div> */}

        <div className={style.moduleSection}>
          <div className={style.sectionHeader}>
            <h3>Course Modules</h3>
          </div>
          <div className={style.moduleGrid}>
            {topicGetData && topicGetData.length > 0 ? (
              topicGetData.map((entry, idx) => {
                const topicsArray = Array.isArray(entry.topics)
                  ? entry.topics
                  : [];
                if (topicsArray.length === 0) return null;
                const moduleId = entry.module_id || entry.topic_id || idx;
                const isExpanded = expandedModule === moduleId;
                return (
                  <div
                    key={moduleId}
                    className={`${style.moduleCard} ${
                      isExpanded ? style.expanded : ""
                    }`}
                    id={moduleId}
                  >
                    <div
                      className={style.moduleHeader}
                      onClick={() => handleExpand(moduleId)}
                    >
                      <div className={style.moduleTitleBox}>
                        <span className={style.moduleNumber}>
                          Module {idx + 1}
                        </span>
                        <h4 className={style.moduleName}>
                          {entry.module_name || "Module"}
                        </h4>
                      </div>
                      <div className={style.expandIcon}>
                        {isExpanded ? "−" : "+"}
                      </div>
                    </div>
                    {isExpanded && (
                      <div className={style.topicsContainer}>
                        {topicsArray.map((t, tIdx) => (
                          <div
                            className={style.topicRow}
                            key={`${idx}-${tIdx}`}
                          >
                            <div
                              className={style.topicInfo}
                              onClick={(event) => {
                                event.stopPropagation();
                                handleCardClick(moduleId, t, entry, tIdx);
                              }}
                            >
                              <div className={style.topicIcon}>
                                <LuBook />
                              </div>
                              <span className={style.topicTitle}>
                                {t.value || t.name || t.topic_name || ""}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className={style.noData}>
                {!loading ? "There is no content to show." : ""}
              </div>
            )}
          </div>
        </div>

        {subscriptionPopup && (
          <div
            className={style.PopupOverlay}
            onClick={() => setSubscriptionPopup(false)}
          >
            <div className={style.SubPopup}>
              <div className={style.subPopTxt}>
                <p>You need to subscribe to Access this Module !!</p>
              </div>
              <div className={style.subBtn}>
                <button onClick={() => setSubscriptionPopup(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {leaderBoardShow ? (
        <>
          <div
            className={style.Overlay}
            onClick={() => {
              setLeaderBoardShow(false);
            }}
          ></div>
          <div className={style.leaderBoard}>
            <div className={style.boardHeader}>
              <h3>LEADER BOARD</h3>
            </div>
            <div className={style.boardSection}>
              {rewardValues &&
                rewardValues.length > 0 &&
                rewardValues.map((value, i) => {
                  return (
                    <div className={style.boardValues} key={i}>
                      <div className={style.valueBadge}>
                        {i === 0 ? (
                          <img src={goldMedal} alt="" />
                        ) : i === 1 ? (
                          <img src={silverMedal} alt="" />
                        ) : i === 2 ? (
                          <img src={brownsMedal} alt="" />
                        ) : (
                          <p>{i + 1}</p>
                        )}
                      </div>
                      <div className={style.valueAvatar}>
                        <IoPersonCircleOutline />
                      </div>
                      <div className={style.playerNameStar}>
                        <p>{value.name}</p>
                      </div>
                      <div className={style.playerNameStar}>
                        <p>
                          Points: <span>{value.points}</span>
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default LearningDetail;
